import React, { useMemo } from 'react';
import { format, isAfter, isBefore, startOfDay, endOfDay, addDays } from 'date-fns';
import { useTodoContext } from '../../context/TodoContext';

const TaskCompletionStats = () => {
  const { todos } = useTodoContext();

  const stats = useMemo(() => {
    const today = new Date();
    const startToday = startOfDay(today);
    const endToday = endOfDay(today);
    const tomorrow = addDays(startToday, 1);
    const nextWeek = addDays(startToday, 7);

    const periods = {
      overdue: { total: 0, completed: 0, tasks: [] },
      today: { total: 0, completed: 0, tasks: [] },
      thisWeek: { total: 0, completed: 0, tasks: [] },
      later: { total: 0, completed: 0, tasks: [] }
    };

    todos.forEach(todo => {
      if (!todo.dueDate) {
        periods.later.total++;
        if (todo.completed) periods.later.completed++;
        periods.later.tasks.push(todo);
        return;
      }

      const dueDate = new Date(todo.dueDate);

      if (isBefore(dueDate, startToday)) {
        periods.overdue.total++;
        if (todo.completed) periods.overdue.completed++;
        periods.overdue.tasks.push(todo);
      } else if (dueDate >= startToday && dueDate <= endToday) {
        periods.today.total++;
        if (todo.completed) periods.today.completed++;
        periods.today.tasks.push(todo);
      } else if (dueDate > tomorrow && dueDate <= nextWeek) {
        periods.thisWeek.total++;
        if (todo.completed) periods.thisWeek.completed++;
        periods.thisWeek.tasks.push(todo);
      } else {
        periods.later.total++;
        if (todo.completed) periods.later.completed++;
        periods.later.tasks.push(todo);
      }
    });

    return periods;
  }, [todos]);

  const calculatePercentage = (completed, total) => {
    if (total === 0) return 0;
    return Math.round((completed / total) * 100);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {Object.entries(stats).map(([period, data]) => {
        const percentage = calculatePercentage(data.completed, data.total);
        
        return (
          <div key={period} className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
            <h3 className="font-semibold text-gray-700 dark:text-gray-300 mb-2">
              {period === 'overdue' && 'Scaduti'}
              {period === 'today' && 'Oggi'}
              {period === 'thisWeek' && 'Questa Settimana'}
              {period === 'later' && 'Futuri'}
            </h3>
            
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-600 dark:text-gray-400">
                {data.completed}/{data.total} completati
              </span>
              <span className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                {percentage}%
              </span>
            </div>
            
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
              <div
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TaskCompletionStats;